// extracted by mini-css-extract-plugin
export var title = "fr_h";
export var titleAndMetadata = "fr_l3";